import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'PhoneMaskingPipe' })
export class PhoneMaskingPipe implements PipeTransform {
  transform(value: string) {
    return value?.replace(/(\d{3})\d*(\d{4})/, '$1****$2');
  }
}

@Pipe({ name: 'TelephoneMaskingPipe' })
export class TelephoneMaskingPipe implements PipeTransform {
  transform(value: string) {
    return value?.replace(/(\d{0})\d*(\d{4})/, '$1****$2');
  }
}

@Pipe({ name: 'CertificateAccountMaskingPipe' })
export class CertificateAccountMaskingPipe implements PipeTransform {
  transform(value: string) {
    return value?.replace(/(\S{3})\S*(\S{4})/, '$1****$2');
  }
}

@Pipe({ name: 'AccountNoMaskingPipe' })
export class AccountNoMaskingPipe implements PipeTransform {
  transform(value: string) {
    return value?.replace(/(\d{6})\d*(\d{4})/, '$1****$2');
  }
}

export function phoneMasking(str) {
  return str?.replace(/(\d{3})\d*(\d{4})/, '$1****$2');
}

export function telephoneMasking(str) {
  return str?.replace(/(\d{0})\d*(\d{4})/, '$1****$2');
}

export function certificateAccountMasking(str) {
  return str?.replace(/(\S{3})\S*(\S{4})/, '$1****$2');
}

export function accountNoMasking(str) {
  return str?.replace(/(\d{6})\d*(\d{4})/, '$1****$2');
}
